import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./ReservationSummary.scss";
import constants from "../../utils/constants";
import { injectIntl } from "react-intl";
import { enhanceWithCollapsible } from "../Collapsible/Collapsible";
import classnames from "classnames";
import { dateDiffInDays, parseDate } from "../../utils/date";
import { Conditions, Extras, RoomReservationCard } from "@witbooking/react-components";
import { executeEvent, getFromSessionStorage, handleGallery, renderHTML } from "../../utils/misc";
import { withSessionData } from "../../utils/session";

function checkExtrasToShow(sortedServices, hideObligatoryExtras) {
  return (
    sortedServices && !(hideObligatoryExtras && sortedServices.every(service => service.obligatory))
  );
}

class ReservationSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allowCloseExtrasModal: true,
      isExtrasModalOpen: false,
    };
    this.handleChangeNumberOfAccommodations = this.handleChangeNumberOfAccommodations.bind(this);
    this.handleServiceGallery = this.handleServiceGallery.bind(this);
    this.handleExtrasModal = this.handleExtrasModal.bind(this);
  }

  handleChangeNumberOfAccommodations(event) {
    this.props.handleChangeNumberOfUnits({
      reservation: this.props.reservation,
      event,
    });
  }

  handleServiceGallery(service) {
    this.props.handleGallery(
      service.media && service.media.length !== 0 ? service.media : [constants.DEFAULT_EXTRA_MEDIA],
      service.name || service.title,
      service.description,
      {},
      null,
      null,
      "service"
    );
  }

  componentDidMount() {
    if (
      !getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.STAY_QUEUE_INDEX) &&
      this.props.latestReservation &&
      checkExtrasToShow(this.props.sortedServices, this.props.hideObligatoryExtras) &&
      (!!this.props.showExtrasModal ||
        this.props.showServices ||
        (this.props.isSharedBooking && this.props.extrasQuestionnaire))
    ) {
      this.setState({ isExtrasModalOpen: true });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      (this.props.activeExtraFilter !== prevProps.activeExtraFilter ||
        this.props.sortedServices !== prevProps.sortedServices ||
        this.state.isExtrasModalOpen !== prevState.isExtrasModalOpen) &&
      this.props.sortedServices &&
      this.props.sortedServices.length > 0 &&
      this.state.isExtrasModalOpen
    ) {
      const extras = (
        <Extras
          extras={this.props.sortedServices}
          selectedServices={this.props.reservation.get("selectedServices").toJS()}
          onChangeService={({ quantity, showedQuantity, forms }) => {
            this.props.onChangeService({
              reservationId: this.props.reservation.get("id"),
              propertyTicker: this.props.reservation.get("propertyTicker"),
              quantity,
              showedQuantity,
              forms,
            });
          }}
          handleGallery={this.handleServiceGallery}
          handleModalContent={this.props.handleModalContent}
          closeWindow={() => {
            this.setState({
              isExtrasModalOpen: false,
            });
            this.props.handleCloseModal();
          }}
          serviceHasImage={this.props.serviceHasImage}
          addObligatoryExtrasRateToRoomSelection={this.props.addObligatoryExtrasRateToRoomSelection}
          startDate={parseDate(this.props.reservation.get("startDate"))}
          endDate={parseDate(this.props.reservation.get("endDate"))}
          questionnaires={this.props.extrasQuestionnaire}
          allowCloseExtrasModal={this.allowCloseExtrasModal}
          allowClose={this.state.allowCloseExtrasModal}
          hideObligatoryExtras={this.props.hideObligatoryExtras}
          guestsList={this.props.guestsList}
          extraFilters={this.props.extraFilters && this.props.extraFilters?.toJS()}
          activeExtraFilter={this.props.activeExtraFilter}
          isTabFiltersCollapsed={this.props.isTabFiltersCollapsed}
          backgroundColor={"#" + this.props.backgroundColor}
          textColor={"#" + this.props.textColor}
        />
      );
      this.handleExtrasModal(this.props.sortedServices, extras);
    }
  }

  allowCloseExtrasModal = bool => {
    if (this.state.allowCloseExtrasModal !== bool) {
      this.setState({ allowCloseExtrasModal: bool });
    }
  };

  handleExtrasModal(services, component) {
    executeEvent(constants.EVENTS.OPENED_SERVICES_MODAL);
    this.props.handleModalContent(component, {
      hideCloseButton: true,
      className: "fullContent",
      styles: {
        overlay: {
          zIndex: "1499",
        },
        content: {
          maxWidth: "930px",
          zIndex: "1499",
          overflow: "hidden",
        },
      },
      shouldCloseOnOverlayClick: this.state.allowCloseExtrasModal,
      shouldCloseOnEsc: this.state.allowCloseExtrasModal,
      handleClose: () =>
        this.setState({
          isExtrasModalOpen: false,
        }),
    });
  }

  render() {
    const { handleChangeNumberOfAccommodations, handleServiceGallery } = this;
    const {
      reservation,
      onRemoveReservation,
      currency,
      toggleExpand,
      fullWidth,
      handleModalContent,
      handleCloseModal,
      cancelRelease,
      addObligatoryExtrasRateToRoomSelection,
      showDiscountsCalculation,
      handleChangeNumberOfUnits,
      maxBookableRooms,
      showBookingOptionSummary,
      intl,
      backgroundColor,
      roomDenomination,
      textColor,
      sortedServices,
      cancellationRestrictions,
      reservationIndex,
      cancellationPoliciesInfo,
      hideObligatoryExtras,
      showBestPriceGuaranteed,
      guestsList,
    } = this.props;

    const handleModal = () => {
      if (reservation.get("inventory") && reservation.get("inventory").get("condition")) {
        handleModalContent(
          <Conditions.PopupConditions
            data={reservation.get("inventory").get("condition").toJS()}
            closeWindow={handleCloseModal}
            restrictions={
              cancellationRestrictions &&
              cancellationRestrictions[reservationIndex][
                reservation.get("inventory").get("condition").get("ticker")
              ]
            }
            cancellationPoliciesInfo={
              cancellationPoliciesInfo &&
              cancellationPoliciesInfo[reservationIndex][
                reservation.get("inventory").get("condition").get("ticker")
              ]
            }
            checkIn={new Date(reservation.get("startDate"))}
            amount={
              reservation.get("discountAmount")
                ? reservation.get("baseRate") - reservation.get("discountAmount")
                : reservation.get("baseRate")
            }
            currency={currency}
            firstNightCost={reservation.getIn(["firstNightCost"])}
            showCancellationTable
            cutOffDate={Date.now()}
          />,
          { hideCloseButton: true, modalWidth: "700px" }
        );
      }
    };
    const startDateObj = parseDate(reservation.get("startDate"));
    const endDateObj = parseDate(reservation.get("endDate"));
    const numberOfNights = dateDiffInDays(startDateObj, endDateObj);
    const maxAvailableBookableRooms = Math.min(
      maxBookableRooms,
      reservation.get("inventory").get("availability")
    );

    const hasDiscounts =
      showDiscountsCalculation &&
      reservation.get("discountAmount") &&
      Math.abs(reservation.get("discountAmount")) > 0;
    const discountAmount =
      (fullWidth && reservation.get("baseRate") - reservation.get("discountAmount")) ||
      reservation.get("discountAmount");

    // TODO use selector
    const extrasToShow = checkExtrasToShow(sortedServices, hideObligatoryExtras);

    const finalRoomDenomination =
      reservation.get("inventory").get("accommodation").get("roomDenomination") ||
      roomDenomination ||
      constants.ROOM_DENOMINATION.UNITS;

    const disableUnit = this.props.session && this.props.session.disableUnit;
    const entity =
      reservation.get("selectedPackage") || reservation.get("inventory").get("accommodation");

    return (
      <div
        className={classnames(
          "wbkv9-ReservationSummary",
          styles.reservationContainer,
          !showBookingOptionSummary && "fastBooking"
        )}>
        <div
          className={classnames(
            "wbkv9-ReservationSummary-reservationWrapper",
            styles.reservationWrapper
          )}>
          <RoomReservationCard
            fullWidth={fullWidth}
            selectValue={reservation.get("numberOfUnits")}
            totalOccupancy={reservation.get("totalOccupancy")}
            selectOnChange={event =>
              handleChangeNumberOfUnits({
                reservation: reservation,
                event,
              })
            }
            accommodationName={reservation.get("inventory").get("accommodation").get("name")}
            selectedPackage={
              reservation.get("selectedPackage") && reservation.get("selectedPackage").toJS()
            }
            addObligatoryExtrasRateToRoomSelection={addObligatoryExtrasRateToRoomSelection}
            baseRate={reservation.get("baseRate")}
            buttonOnClick={() => {
              this.setState({
                isExtrasModalOpen: true,
              });
            }}
            cancelRelease={cancelRelease}
            conditionName={reservation.get("inventory").get("condition").get("name")}
            currency={currency}
            disableUnit={disableUnit}
            discountAmount={reservation.get("discountAmount")}
            discountDiff={discountAmount}
            endDate={reservation.get("endDate")}
            handleChangeNumberOfUnits={handleChangeNumberOfAccommodations}
            handleGallery={handleServiceGallery}
            handleRoomGallery={() =>
              handleGallery(this.props.handleModalContent, this.props.handleGallery)(
                entity.get("media").toJS(),
                entity.get("name"),
                entity.get("description"),
                reservation.get("propertyTicker"),
                undefined,
                undefined,
                undefined,
                true
              )
            }
            handleModal={handleModal}
            hasDiscounts={hasDiscounts}
            hasSelectedServices={reservation.get("selectedServices").size > 0}
            hasServices={sortedServices && sortedServices.length > 0}
            intl={intl}
            maxAvailableBookableRooms={maxAvailableBookableRooms}
            mealPlan={reservation.get("inventory").get("mealplan").get("name")}
            numberOfNights={numberOfNights}
            numberOfUnits={reservation.get("numberOfUnits")}
            occupantsList={reservation.get("inventory").get("configuration").get("name")}
            onRemoveReservation={() => {
              onRemoveReservation(reservation);
            }}
            reservationStartDate={reservation.get("startDate")}
            roomDenomination={finalRoomDenomination}
            selectedServices={reservation.get("selectedServices").toJS()}
            serviceRatesInfo={reservation.get("serviceRatesInfo").toJS()}
            showDiscountsCalculation={showDiscountsCalculation}
            startDate={reservation.get("startDate")}
            toggleExpand={toggleExpand}
            totalRate={reservation.get("totalRate")}
            backgroundColor={backgroundColor}
            textColor={textColor}
            restrictions={
              cancellationRestrictions &&
              cancellationRestrictions[reservationIndex][
                reservation.get("inventory").get("condition").get("ticker")
              ]
            }
            cutOffDate={Date.now()}
            onCancellationMessageClick={this.handleModal}
            hideObligatoryExtras={this.props.hideObligatoryExtras}
            extrasToShow={extrasToShow}
            showBestPriceGuaranteed={showBestPriceGuaranteed}
          />
        </div>
      </div>
    );
  }
}

// TODO: Correct proptypes
// ReservationSummary.propTypes = {
//   reservation: PropTypes.object.isRequired,
//   onRemoveReservation: PropTypes.func,
//   onChangeService: PropTypes.func,
//   currency: PropTypes.string,
//   handleGallery: PropTypes.func,
//   expanded: PropTypes.bool,
//   toggleExpand: PropTypes.func,
//   expandedClassName: PropTypes.string,
//   fullWidth: PropTypes.bool,
//   childrenClassName: PropTypes.string,
//   handleModalContent: PropTypes.func,
//   handleCloseModal: PropTypes.func,
//   cancelRelease: PropTypes.bool,
//   serviceHasImage: PropTypes.bool,
//   pendingAmountTextConfiguration: PropTypes.string,
//   addObligatoryExtrasRateToRoomSelection: PropTypes.bool,
//   handleChangeNumberOfUnits: PropTypes.func,
//   maxBookableRooms: PropTypes.number,
//   showBookingOptionSummary: PropTypes.bool,
//   showDiscountsCalculation: PropTypes.bool,
//   roomDenomination: PropTypes.string,
//   intl: PropTypes.object,
//   showServices: PropTypes.bool,
//   backgroundColor: PropTypes.string,
//   textColor: PropTypes.string,
//   extrasQuestionnaire: PropTypes.array,
//   sortedServices: PropTypes.array,
//   showExtrasModal: PropTypes.bool,
//   cancellationRestrictions: PropTypes.array.isRequired,
//   reservationIndex: PropTypes.number,
//   cancellationPoliciesInfo: PropTypes.array,
//   latestReservation: PropTypes.bool,
//   hideObligatoryExtras: PropTypes.bool,
//   showBestPriceGuaranteed: PropTypes.bool,
//   guestsList: PropTypes.object
// };

export default enhanceWithCollapsible(injectIntl(withSessionData(ReservationSummary)));
